
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resume-application",
      function () {
        return require("private-next-pages/resume-application.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resume-application"])
      });
    }
  